import "./cash_account_tooltip.css"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {useTranslation} from "react-i18next";

function CashTooltip() {

    const {t} = useTranslation()

    return (
        <>
            <OverlayTrigger
                placement='bottom'
                overlay={
                    <Tooltip id={`tooltip-bottom`}>
                        {t('tooltip.cash_tooltip')}
                    </Tooltip>
                }
            >
                <div className="hover-account-text">
                    <span>{t('account.cash')}</span>
                </div>
            </OverlayTrigger>
        </>
    );
}

export default CashTooltip;